import { configureStore } from '@reduxjs/toolkit';
import reducer from './reducers/reducer'
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
// redux-persist config
const persistConfig = {
    key: "root",
    storage,
};

// Wrap the root reducer with persistReducer
const persistedReducer = persistReducer(persistConfig, reducer);
export const store = configureStore({
    reducer: {
        root: persistedReducer,
    },
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
